import React, {useEffect} from "react";
import LoginBox from "../components/Login/LoginBox";
import {SignOut} from "../utils/auth";
const LoginPage = () => {
  // Limpia las flags del localStorage para evitar que arrastre problemas.
  useEffect(() => {
    SignOut();
  }, []);

  return (
    <div className="login-page">
      <div className="row login-container g-5">
        <div className="col login-title">
          <p>Bienvenido a </p>
          <h1>Acreditaciones de prensa</h1>
        </div>
        <div className="col">
          <LoginBox />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
